import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import api from "../../services/api";
import KnowledgeSourceGroups from "../KnowledgeSourceGroups";

export default function MessageKnowledgeDialog({ messageId, onClose }) {
  const [state, setState] = useState({ loading: true });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    if (!messageId) return undefined;
    let active = true;
    setState({ loading: true });
    api.get(`/messages/${messageId}/knowledge`).then(({ data }) => {
      if (active) setState({ data });
    }).catch(() => {
      if (active) setState({ error: true });
    });
    return () => { active = false; };
  }, [messageId, retry]);
  return <Dialog open={Boolean(messageId)} onClose={onClose} fullWidth maxWidth="sm" aria-labelledby="message-knowledge-title">
    <DialogTitle id="message-knowledge-title">Fontes da resposta</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="textSecondary" paragraph>Detalhes internos da resposta original. Estas referências não são enviadas ao contato.</Typography>
      {state.loading && <div role="status"><CircularProgress size={20} /> Carregando referências...</div>}
      {state.error && <Alert severity="error" action={<Button onClick={() => setRetry(value => value + 1)}>Tentar novamente</Button>}>Não foi possível consultar as referências. Verifique seu acesso ao atendimento.</Alert>}
      {state.data && <>
        {(state.data.isEdited || state.data.isDeleted) && <Alert severity="info">A mensagem foi editada ou excluída após o envio. As referências registradas correspondem à resposta original.</Alert>}
        <KnowledgeSourceGroups items={state.data.references} />
        {state.data.correlationId && <Typography variant="caption" color="textSecondary" component="p" style={{ overflowWrap: "anywhere" }}>Correlação: {state.data.correlationId}</Typography>}
      </>}
    </DialogContent>
    <DialogActions><Button onClick={onClose}>Fechar</Button></DialogActions>
  </Dialog>;
}
